export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.loadComparisonCategories = payload;

  return newState;
};
